import {isMobileOnly} from "react-device-detect";
import {Redirect, Route, Switch} from "react-router-dom";
import WebsiteMainLoginView from "@/Domains/AuthenticationManagement/WebsiteMainLoginView";
import WebsiteMainAppcodeView from "@/Domains/AuthenticationManagement/WebsiteMainAppcodeView";
import React from "react";
import UserTokenMainQueryRenderer from "@/Domains/AuthenticationManagement/Usertoken/Queryrenderer/UserTokenMainQueryRenderer";

export default function WebsiteComponent() {
    if (isMobileOnly) {
        return <>Use Other device!</>;
    }

    return (
        <Switch>
            <Route path="/login">
                <WebsiteMainLoginView/>
            </Route>
            <Route path="/appcode">
                <WebsiteMainAppcodeView/>
            </Route>
            <Route path="/user/create/:token">
                <UserTokenMainQueryRenderer/>
            </Route>
            <Route path="/">{<Redirect to="/login"/>}</Route>
        </Switch>
    );
}
